import { type FC } from "react";

import { Alert } from "@snapchat/snap-design-system";

import { DISTRIBUTIONS_DOCS_LINK } from "../constants";

import {
    DistributionRestrictionsDocsLinkText,
    DistributionRestrictionsWarningAction,
    DistributionRestrictionsWarningMessage,
    DistributionRestrictionsWarningTitle,
} from "./messages.generated";

interface LensDistributionRestrictionsWarningProps {
    onActionClick: () => void;
    className?: string;
}

export const LensDistributionRestrictionsWarning: FC<LensDistributionRestrictionsWarningProps> = ({
    className,
    onActionClick,
}) => {
    return (
        <Alert
            title={<DistributionRestrictionsWarningTitle />}
            status="warning"
            className={className}
            message={
                <DistributionRestrictionsWarningMessage
                    docsLink={
                        <a href={DISTRIBUTIONS_DOCS_LINK} target="_blank" rel="noopener noreferrer">
                            <DistributionRestrictionsDocsLinkText />
                        </a>
                    }
                />
            }
            actionText={<DistributionRestrictionsWarningAction />}
            onActionClick={onActionClick}
        />
    );
};
